import React from "react"
import { BsList } from 'react-icons/bs';
import pageLinks from "../constants/links"
import { Link } from "gatsby"

const Navbar = ({ toggleSidebar }) => {
  return (
    <nav className="navbar">
      <div className="nav-center">
        <div className="nav-header">
        <Link to="/" class="nav-brand">
						<h3 class="logotype">ZIZI <span>.</span></h3>
					</Link>
          <button type="button" className="toggle-btn" onClick={toggleSidebar}>
          <BsList />
          </button>
        </div>
        <ul className="nav-links">
          {pageLinks.map(link => {
            return (
              <li key={link.id}>
      <Link activeStyle={{ color:"#617d98"}} to={link.url}>{link.text}</Link>
    </li>
            )
          })}
        </ul>
      </div>
    </nav>
  )
}

export default Navbar



